import { Capacitor } from '@capacitor/core';
import { SafeArea } from '@capacitor-community/safe-area';

class SafeAreaHelper {
  constructor() {
    this.safeAreaInsets = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    };
    this.initialized = false;
  }

  async initialize() {
    if (this.initialized) return;

    try {
      if (Capacitor.getPlatform() !== 'web') {
        const safeArea = await SafeArea.getSafeAreaInsets();
        this.safeAreaInsets = safeArea.insets;
        this.applySafeAreaCSS();
      } else {
        // Fallback for web - detect if safe area is supported
        this.detectWebSafeArea();
      }
      this.initialized = true;
    } catch (error) {
      console.warn('SafeArea plugin not available, falling back to CSS env() variables', error);
      this.detectWebSafeArea();
      this.initialized = true;
    }
  }

  detectWebSafeArea() {
    // Check if browser supports safe area insets
    const testDiv = document.createElement('div');
    testDiv.style.paddingTop = 'env(safe-area-inset-top)';
    document.body.appendChild(testDiv);
    
    const computedStyle = getComputedStyle(testDiv);
    const hasSupport = computedStyle.paddingTop !== '0px';
    
    document.body.removeChild(testDiv);
    
    if (!hasSupport) {
      // Fallback: Detect if we're likely on a device with notch/safe areas
      this.applyFallbackSafeAreas();
    }
  }

  applyFallbackSafeAreas() {
    const isLikelyNotchedDevice = window.screen.height > window.screen.width * 1.8;
    const hasDisplayCutout = window.screen.width > 400 && window.screen.height > 800;
    
    if (isLikelyNotchedDevice || hasDisplayCutout) {
      this.safeAreaInsets = {
        top: 24,
        bottom: 16,
        left: 0,
        right: 0,
      };
      this.applySafeAreaCSS();
    }
  }

  applySafeAreaCSS() {
    const style = document.createElement('style');
    style.textContent = `
      :root {
        --safe-area-inset-top: ${this.safeAreaInsets.top}px;
        --safe-area-inset-bottom: ${this.safeAreaInsets.bottom}px;
        --safe-area-inset-left: ${this.safeAreaInsets.left}px;
        --safe-area-inset-right: ${this.safeAreaInsets.right}px;
      }
      
      .force-safe-area-top {
        padding-top: ${this.safeAreaInsets.top}px !important;
      }
      
      .force-safe-area-bottom {
        padding-bottom: ${this.safeAreaInsets.bottom}px !important;
      }
      
      ion-app {
        padding-top: ${this.safeAreaInsets.top}px;
        padding-bottom: ${this.safeAreaInsets.bottom}px;
      }
    `;
    document.head.appendChild(style);
  }

  getSafeAreaInsets() {
    return this.safeAreaInsets;
  }

  addSafeAreaClass(element, sides = ['top', 'bottom']) {
    if (!element) return;
    
    sides.forEach(side => {
      if (this.safeAreaInsets[side] > 0) {
        element.classList.add(`force-safe-area-${side}`);
      }
    });
  }
}

export const safeAreaHelper = new SafeAreaHelper();
export default SafeAreaHelper;